export class LocaleHelper {
    private static countryToLocale: Map<string, string> = new Map([
        ['fr', 'fr-BE'],
        ['nl', 'nl-BE'],
        ['en', 'en-EN'],
    ]);
    public static mapCountryAccronymToLocale(accr: string): string {
        return this.countryToLocale.get(accr) ?? 'fr-BE';
    }
}
